import React from 'react'

import { Form, Col } from '_zari/core'

import { RounderUtil } from 'utils'

const MargenUtilidadReposicionFormGroup = ({ vPrecioNeto, infoCostosProducto }) => {
  const [utilidadCalculada, setUtilidadCalculada] = React.useState(0)

  React.useEffect(() => {
    if (vPrecioNeto && infoCostosProducto.costoReposicion) {
      const diferencia = RounderUtil.round(vPrecioNeto - infoCostosProducto.costoReposicion, 4)
      const utilidad = RounderUtil.round((diferencia / infoCostosProducto.costoReposicion) * 100, 2)
      setUtilidadCalculada(utilidad)
    } else {
      setUtilidadCalculada(0)
    }
  }, [vPrecioNeto, infoCostosProducto])

  return (
    <Form.Group>
      <Form.Label text='% UTIL REPO' htmlFor='input-margenUtilidadReposicion' xs={12} />
      <Col xs={12}>
        <Form.InputText
          disabled
          id='input-margenUtilidadReposicion'
          name='input-margenUtilidadReposicion'
          value={utilidadCalculada}
          onChange={() => ({})}
          isInvalid={utilidadCalculada < 0}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(MargenUtilidadReposicionFormGroup)
